/**
 * @file 前端性能监控 - RUM
 * @author gaoxunchen
 * @link 介绍 https://cloud.tencent.com/document/product/1464
 * @link 控制台 https://console.cloud.tencent.com/rum/web/group-projects-manage
 */

import Aegis from '@tencent/aegis-web-sdk';

const ignoreUrl = [
  'agency.woa.com/data-report-hub/api',
  'otheve.beacon.qq.com',
  'localhost:3000',
];

const aegis = new Aegis({
  // 上报 id
  id: 'VDEqlUdPDEJzowrxgw',
  // 接口测速
  reportApiSpeed: true,
  // 静态资源测速
  reportAssetSpeed: true,
  // spa 应用页面跳转的时候开启 pv 计算
  spa: true,
  hostUrl: 'https://rumt-zh.com',
  // 环境
  env: process.env.DEPLOY_ENV === 'production' ? Aegis.environment.production : Aegis.environment.test,
  // api
  api: {
    // 上报 api 的请求参数和返回值
    apiDetail: true,
    // 开启后，aegis.info 会变成全量上报
    reportRequest: true,
    // 钩子函数: 返回码上报
    retCodeHandler: (data: any, url: string, xhr: Record<string, any>) => {
      // 非当前域名请求不上报为异常
      if (!url.includes(window.location.host)) {
        return {
          isErr: false,
          code: xhr?.status,
        };
      }

      // 数据上报中心
      if (url.includes('/data-report-hub/')) {
        return {
          isErr: xhr?.status !== 200,
          code: xhr?.status,
        };
      }

      // 销售
      if (url.includes('/ags/')) {
        return {
          isErr: xhr?.status !== 200,
          code: xhr?.status,
        };
      }

      try {
        const { code } = JSON.parse(data);

        // 无极配置
        if (url.includes('/wuji')) {
          return {
            isErr: xhr?.status !== 200 || code !== 200,
            code,
          };
        }

        // 默认接口
        return {
          code,
          isErr: code !== 0,
        };
      } catch (e) {}
    },
  },
  // 钩子函数: 数据上报前
  beforeRequest: (data: Record<string, any>) => {
    // 入参data的数据结构：{logs: {…}, logType: "log"}

    // 非正式环境不上报
    if (process.env.DEPLOY_ENV !== 'production') {
      return false;
    }
    let isIgnore = false;
    if (data.logType === 'log' && data.logs.msg.includes('sendBeacon')) {
      isIgnore = true;
    } else {
      isIgnore = ignoreUrl.some((url) => {
        if (data.logType === 'log' && data.logs.msg.includes(url)) {
          return true;
        }
        if (data.logType === 'speed' && data.logs.url.includes(url)) {
          return true;
        }
        return false;
      });
    }

    // 拦截上报日志
    if (isIgnore) {
      return false;
    }
  },
});

export default aegis;
